import styled from "styled-components";
import CheckCircleOutlined from "@mui/icons-material/Circle";
import { colors } from "healthex-common/colors";
import { FlexColumnDiv } from "./common.styles";
export const TimelineDot = styled(CheckCircleOutlined) `
    width: 12px;
    height: 12px;
    color: ${colors.sunset_main};
`;
export const TimelineVerticalDividerContainer = styled(FlexColumnDiv) `
    width: 12px;
    align-items: center;
`;
export const TimelineVerticalDivider = styled.div `
    width: 2px;
    height: 35px;
    background-color: ${colors.sunset_main};
    flex-grow: 1;
`;
export const TimelineVerticalPlaceholder = styled.div `
    flex-grow: 1;
`;
export const TimeLineDotAndLineViewContainer = styled(FlexColumnDiv) `
    width: 12px;
    align-items: center;
    gap: 16px;
`;
